import filesizeLib from 'filesize';
import mimeLib from 'mime';
import { nonNullable } from '~/lib/jsTools/nonNullable';

export const isPdfFile = (mime: string): boolean => mime === 'application/pdf';
export const isImageFile = (mime: string): boolean => mime.startsWith('image/');

export const blobToDataUrl = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result as string);
    fileReader.onerror = () => reject(fileReader.error);
    fileReader.readAsDataURL(blob);
  });
};

export const fileToArrayBuffer = (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result as ArrayBuffer);
    fileReader.onerror = () => reject(fileReader.error);
    fileReader.readAsArrayBuffer(file);
  });
};

export const downloadBlob = (blob: Blob, filename: string): void => {
  const blobData = new Blob([blob], { type: 'application/octet-stream' });
  const blobUrl = URL.createObjectURL(blobData);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 200);
};

export const buildFormData = <T>(data: T): FormData => {
  const formData = new FormData();
  Object.entries(data).forEach(([k, v]) => formData.append(k, v));
  return formData;
};

export const filesize = (size: number): string => filesizeLib(size, { base: 2, standard: 'jedec' });

export const getFileExtensionFromMime = (mime: string): string =>
  nonNullable(mimeLib.getExtension(mime), `no extension for mime ${mime}`);

export const getMimeFromFileExtension = (ext: string): string =>
  nonNullable(mimeLib.getType(ext), `no mime for extension ${ext}`);

export const selectFile = (allowedFileExtensions: string[] = []): Promise<File> => {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';

    if (allowedFileExtensions.length > 0) {
      input.accept = allowedFileExtensions.map(getMimeFromFileExtension).join(',');
    }

    input.addEventListener('change', () => {
      const selectedFile = input.files?.[0];
      if (selectedFile) {
        resolve(selectedFile);
      } else {
        reject(new Error('No file selected'));
      }
    });

    input.click();
  });
};
